const localeMap = {
  en: "/",
  fr: "/fr/",
  es: "/es/",
  it: "/it/",
  nl: "/nl/",
  zh: "/zh-hk/",
};

export const createMarriottHotelLink = (
  crsCode: string,
  locale: Omit<ContentfulLocale, "cn">,
) => {
  const baseUrl = "https://www.marriott.com";

  const localeSlug = localeMap[locale as keyof typeof localeMap];
  if (!localeSlug) {
    throw new Error("invalid locale used to build Marriott hotel link");
  }
  return `${baseUrl}${localeSlug}${crsCode}`;
};

export const createMarriottReservationLink = (params: {
  crsCode: string;
  locale: ContentfulLocale;
  fromDate: Date | string;
  toDate: Date | string;
  rooms: number;
  guests: number;
}) => {
  const { crsCode, locale, guests, rooms, toDate, fromDate } = params;
  const localeSlug = localeMap[locale as keyof typeof localeMap];

  if (!crsCode) {
    throw new Error("Crs code is required to build Marriott reservation link");
  }

  if (!localeSlug) {
    throw new Error(
      "invalid locale used to build Marriott reservation link: " + locale,
    );
  }

  const from = typeof fromDate === "string" ? new Date(fromDate) : fromDate;
  const to = typeof toDate === "string" ? new Date(toDate) : toDate;

  return `https://www.marriott.com${localeSlug}reservation/availabilitySearch.mi?propertyCode=${crsCode}&fromDate=${from.toLocaleDateString("en-US")}&toDate=${to.toLocaleDateString("en-US")}&numberOfRooms=${rooms}&numberOfAdults=${guests}`;
};
